import { all } from 'redux-saga/effects';

import authSaga from '../../auth/store/authSaga';
import galleryTagsSaga from '../../gallery-tags/store/sagas/galleryTagsSaga';
import leadsysPictureSaga from '../../leadsys-pictures/store/sagas/leadsysPictureSaga';
import configLoaderSaga from '../config-loader/store/config-loader-saga';

export function* rootSaga() {
  yield all([configLoaderSaga(), authSaga(), leadsysPictureSaga(), galleryTagsSaga()]);
}

export default rootSaga;
